import { type FC, useEffect } from 'react';
import { getPriceAttr } from 'dibs-intl/exports/helpers';
import { useCurrencyStore } from '../../hooks/currencyStore/currencyStore.ts';

export const PriceIntlHandler: FC = () => {
    const { currency } = useCurrencyStore();

    useEffect(() => {
        const priceElements = document.querySelectorAll(`[${getPriceAttr(currency)}]`);
        if (priceElements.length) {
            const priceAttr = getPriceAttr(currency);
            priceElements.forEach(el => {
                el.textContent = el.getAttribute(priceAttr);
            });
        }
    }, [currency]);

    return null;
};
